import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=6615460c&"
import script from "./Images.vue?vue&type=script&lang=ts&"
export * from "./Images.vue?vue&type=script&lang=ts&"
import style0 from "./Images.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports